import script from "./ThreePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreePage.vue?vue&type=script&setup=true&lang=js"

import "./ThreePage.vue?vue&type=style&index=0&id=3f486df5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f486df5"]])

export default __exports__